import React, { useEffect, useState } from 'react';
import { EmbedWrapper } from './Embed.styled';
import Player from "components/Player/Player";
import useFetchSourceHeaders from "hooks/fetchSourceHeaders";
import { IMedia } from "models/media.model";
import { VideoJsPlayer } from "video.js";
import { getCurrentVideo } from "helpers/current-video.helper";
import { usePlayerConfigContext } from "providers/PlayerConfig.provider";
import { useIdAndStateContext } from "providers/IdAndState.provider";

function Embed() {

  const {data} = usePlayerConfigContext();
  const {id} = useIdAndStateContext();


  const [player, setPlayer] = useState<VideoJsPlayer>();
  const [currentVideo, SetCurrentVideo] = useState<IMedia>()


  useFetchSourceHeaders(currentVideo?.source as string);

  useEffect(() => {
    if (player) {
      let currentVideo = getCurrentVideo(player as VideoJsPlayer, data?.media as IMedia[]);
      SetCurrentVideo(currentVideo)

      player.one('play', () => {
        if ((data?.media as IMedia[]).length > 1) {
          currentVideo = (data?.media as IMedia[])[player.playlist.currentIndex()];
          SetCurrentVideo(currentVideo);
        }
      });
    }

  }, [id, player, currentVideo]);

  return (
    <EmbedWrapper data-testid="Embed">
      {data &&
        <Player
          page={'embed'}
          playerConfig={data}
          onPlayerReady={(player) => setPlayer(player)}/>}
    </EmbedWrapper>

  )
}

export default Embed;
